import * as React from "react"
import { useEffect } from "react";
import {DatePickerSeeker} from "@ui-seeker/core"
import {getPreviousDate} from "@ui-seeker/utils";

import {prevSingleDate, currentSingleDate} from "@signals";


export default function DIPPrevSingleDatePicker({ ...props }) {

    useEffect(() => {
        prevSingleDate.value = getPreviousDate({ days: 1 }, currentSingleDate.value)
    },[currentSingleDate.value])

    return <DatePickerSeeker
        disabled={props?.disabled}
        label="Previous Date"
        value={prevSingleDate.value}
        onChange={e => prevSingleDate.value = e}
        {...props}
    />
}